const BSA_COEFFICIENT = 0.016667;
const BSA_HEIGHT_POWER = 0.5;
const BSA_WEIGHT_POWER = 0.5;

export function calculateBodySurfaceArea({ heightCm, weightKg }) {
  const h = Number(heightCm), w = Number(weightKg);
  if (isNaN(h) || isNaN(w) || h <= 0 || w <= 0) return null;
  const bsa = BSA_COEFFICIENT * Math.pow(h, BSA_HEIGHT_POWER) * Math.pow(w, BSA_WEIGHT_POWER);  
  return bsa;
}
